import { NfSearchFilter, NfSearchRequest } from './models/nf-search.model';

export class NfListLoad {
  static readonly type = '[NfList] Load';
  constructor(public payload: NfSearchRequest) {}
}

export class NfListSetFilter {
  static readonly type = '[NfList] Set Filter';
  constructor(public filter: Partial<NfSearchFilter>) {}
}

export class NfListSetInitialState {
  static readonly type = '[NfList] Set Initial State';
}
